import React, { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";

import { refetchCustomer } from "../queries/global";

import {
  NotificationContext,
  handleError,
} from "../context/NotificationContext";

import * as QUERIES from "../queries/query-functions";

export default function LogoutButton() {
  const { notification, setNotification } = useContext(NotificationContext);

  let navigate = useNavigate();

  const logOut = useMutation({
    mutationFn: () => QUERIES.logOut(),
    onError: (error) => {
      handleError(error.message, setNotification);
    },
    onSuccess: (data) => {
      navigate("/login");
      refetchCustomer();
    },
  });

  return (
    <button
      type="button"
      className="btn btn--logout"
      onClick={() => logOut.mutateAsync()}
    >
      Logout
    </button>
  );
}
